import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path d="M0,0 L100,0 L100,100 L0,100 Z" fill="none" stroke="currentColor" strokeWidth="0.5" />
        </svg>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
        {/* Top Section - Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/9d06b718332fff8e050249d6edbe5f33.png"
              alt="Levalo"
              className="h-10 w-auto mb-6 brightness-0 invert"
            />
            <p className="font-serif text-lg leading-relaxed mb-6">
              Soluções imobiliárias com excelência e transparência
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/levaloimoveis" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary transition-all cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://www.instagram.com/levaloimoveis/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary transition-all cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary transition-all cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary transition-all cursor-pointer">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Navigation */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-6">Navegação</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('conceito')} className="hover:underline cursor-pointer">
                  O ATMOS
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('localizacao')} className="hover:underline cursor-pointer">
                  Localização
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('plantas')} className="hover:underline cursor-pointer">
                  Plantas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('disponibilidade')} className="hover:underline cursor-pointer">
                  Disponibilidade
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contato')} className="hover:underline cursor-pointer">
                  Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Empreendimento */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-6">ATMOS</h3>
            <ul className="space-y-3">
              <li>326 unidades</li>
              <li>Estúdios, 1 e 2 quartos</li>
              <li>Entrega Set/2028</li>
              <li>Centro - Curitiba</li>
              <li className="pt-2">
                <strong>ATR Incorporadora</strong>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-6">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-whatsapp-line mt-1"></i>
                <span>(41) 98867-4555</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Rua São Pedro 43, 20º andar</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-2-line mt-1"></i>
                <span>CEP 80.035-020</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-building-line mt-1"></i>
                <span>Curitiba - PR</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-file-text-line mt-1"></i>
                <span>CNPJ: 52.736.150/0001-61</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section - Copyright */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col lg:flex-row items-center justify-between space-y-4 lg:space-y-0">
            <p className="text-sm text-center lg:text-left">
              © 2025 Levalo Soluções Imobiliárias - CNPJ 52.736.150/0001-61
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/politica-de-privacidade" className="text-sm hover:underline cursor-pointer">
                Política de Privacidade
              </Link>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm hover:underline cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
          <p className="text-xs text-white/70 mt-6 text-center lg:text-left leading-relaxed">
            <strong>Aviso Legal:</strong> As informações, valores e disponibilidade podem ser alterados sem aviso prévio. 
            As imagens são meramente ilustrativas. Consulte condições atualizadas com a Levalo Soluções Imobiliárias.
          </p>
        </div>
      </div>
    </footer>
  );
}
